<template>
    <!-- 主机实例详情中的快照组件（仅仅在instance中cloudydetail引用和云环境中的快照不是同一个组件）-->
    <div class="layout-rctable-container int-snapshot">
        <div class="table-container">
            <rcTable ref="intsnapTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refreshFun"
                        type="default">
                    <i class="icon-common icon-refresh-o-2"></i>
                </Button>
            </rcTable>
        </div>
    </div>
</template>
<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'intsnapshot',
    props: ['baseInfo', 'isLocak'],
    components: {
        rcTable
    },
    data: function () {
        return {
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.SNAPSHOTS, true),
                    params: {
                        cloudEnvId: this.baseInfo.cloudEnvId,
                        resVmId: this.$route.params.id
                    }
                },
                searchShow: false,
                columnsChooseShow: true,
                isMultiSelect: false,
                columns: [
                    {
                        title: this.$i18n.t('名称'),
                        key: 'nameLike',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: false,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.name } }, params.row.name)
                        }
                    },
                    {
                        title: this.$i18n.t('资源ID'),
                        key: 'uuid',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.uuid } }, params.row.uuid)
                        }
                    },
                    {
                        title: this.$i18n.t('快照大小GB'),
                        key: 'snapshotSize',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', this.stringUtil(params.row.snapshotSize))
                        }
                    },
                    {
                        title: this.$i18n.t('创建时间'),
                        key: 'createdDt',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                        }
                    },
                    {
                        title: this.$i18n.t('描述'),
                        key: 'description',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.description } }, params.row.description)
                        }
                    },
                    {
                        title: this.$i18n.t('状态'),
                        key: 'status',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', { style: (params.row.status === '01' ? 'color:#ffcc00' : 'display:none') }, '创建中'),
                                h('span', { style: (params.row.status === '02' ? 'color:#19be6b' : 'display:none') }, '创建成功'),
                                h('span', { style: (params.row.status === '03' ? 'color:#ed3f14' : 'display:none') }, '创建失败'),
                                h('span', { style: (params.row.status === '04' ? 'color:#ffcc00' : 'display:none') }, '删除中'),
                                h('span', { style: (params.row.status === '05' ? 'color:#19be6b' : 'display:none') }, '回滚中')
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
        // openstack,Escloud 添加快照大小字段
        if (!['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin'].includes(this.baseInfo.cloudEnvType)) {
            this.tableAttr.columns.splice(2, 1)
        }
    },
    methods: {
        stringUtil (value) {
            if (value === '' || value === undefined || value === null) {
                return '--'
            } else {
                return value
            }
        },
        // 刷新
        refreshFun () {
            this.$refs.intsnapTable && this.$refs.intsnapTable.refreshTable({
                cloudEnvId: this.baseInfo.cloudEnvId,
                resVmId: this.$route.params.id
            })
        }
    }
}
</script>
<style lang="less" scoped>
.int-snapshot {
    .table-container {
        padding: 0;
    }
}
</style>
